"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONPointer = void 0;
var TDPath_1 = require("../TDPath");
/**
 * <pre>
 * Implementation of JSONPointer with following specs and extensions
 *
 * 1. swagger spec of ref: https://swagger.io/docs/specification/using-ref/
 * 2. relative json pointer: https://json-schema.org/draft/2019-09/relative-json-pointer.html
 * 3. json-schema using id with ref: https://json-schema.org/understanding-json-schema/structuring.html#using-id-with-ref
 *
 * Different from specs:
 * 1. Doesn't support tailing # to indicate the key. Which is not necessary
 * 2. Support ".." as parent, "." as current relative node
 *
 * Examples:
 * 1. URL + Anchor:  http://a.com/path#/p1/p2
 * 2. URL only:  http://a.com
 * 3. Anchor only:  #/p1/p2
 * 4. Relative with number: 2/p1/p2
 * 5. Relative with anchor: ../p1/p2
 * 6. Anchor with $id reference:  [http://a.com/path]#nodeId
 * </pre>
 */
var JSONPointer = /** @class */ (function () {
    function JSONPointer() {
    }
    JSONPointer.get = function () {
        return new JSONPointer();
    };
    JSONPointer.prototype.parse = function (str, supportRelativeWithNum) {
        if (supportRelativeWithNum === void 0) { supportRelativeWithNum = false; }
        var path = new TDPath_1.TDPath();
        if (!str)
            return path;
        if (str.length > 1 && (str.endsWith('#') || str.endsWith('/')))
            // Ignore the last # or / which indicate "key" of the map
            str = str.substring(0, str.length - 1);
        if (str.indexOf('#') < 0) {
            if (this.parseParts(str, path, supportRelativeWithNum))
                return path;
            path.docPath = str;
            path.addParts(TDPath_1.Part.ofRoot());
        }
        else {
            var strs = str.split('#');
            if (strs[0])
                path.docPath = strs[0];
            this.parseParts(strs[1], path, false);
        }
        return path;
    };
    JSONPointer.prototype.parseParts = function (str, path, relativeWithNum) {
        var parts = str.split('/');
        if (relativeWithNum) {
            var level = Number.parseInt(parts[0]);
            if (Number.isNaN(level))
                return false;
            path.addParts(TDPath_1.Part.ofRelative(level));
        }
        else {
            if (!parts[0])
                path.addParts(TDPath_1.Part.ofRoot());
            else if ('.' === parts[0])
                path.addParts(TDPath_1.Part.ofRelative(0));
            else if ('..' === parts[0])
                path.addParts(TDPath_1.Part.ofRelative(1));
            else
                path.addParts(TDPath_1.Part.ofChildOrId(parts[0], parts[0]));
        }
        for (var i = 1; i < parts.length; i++) {
            path.addParts(this.parsePart(parts[i]));
        }
        return true;
    };
    JSONPointer.prototype.parsePart = function (str) {
        str = str.replace('~1', '/').replace('~0', '~');
        return TDPath_1.Part.ofChild(str);
    };
    JSONPointer.prototype.query = function (node, path) {
        return node.getByPath(this.parse(path));
    };
    return JSONPointer;
}());
exports.JSONPointer = JSONPointer;
//# sourceMappingURL=JSONPointer.js.map